module.exports = __webpack_public_path__ + "static/poster-tab-41c5e72bd5b69898cea77502988aa557.jpg";